import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { environment } from '../../../../../environments/environment';
import { CdnService } from '../../../../_services/_cdn/cdn.service';
import { ShgProfileService } from '../../../../_services/_profile/shg-profile.service';
import { VoProfileService } from '../../../../_services/_profile/vo-profile.service';
import { CommonService } from '../../../../_services/_common/common.service';
import { ImageTypeEnum } from '../../../../_enum/common.enum';
import { catchError, forkJoin, of, tap } from 'rxjs';
@Component({
    selector: 'lokos-registration-certificate',
    templateUrl: './registration-certificate.component.html',
    styleUrls: ['./registration-certificate.component.scss'],
    standalone: false,
})
export class RegistrationCertificateComponent implements OnInit {
    breadcrumbs: any[] = [];
    todayData: any = new Date();
    shgId: any;
    shgName: any;
    shgCode: any;
    micCode: any;
    contId: any;
    contName: any;
    contCode: any;
    stateId: any;
    districtId: any;
    blockId: any;
    panchayatId: any;
    villageId: any;
    stateName: any;
    distName: any;
    blockName: any;
    panchayatName: any;
    villageName: any;
    errorMessage: any;
    shgMembersLists: any;
    formationDate: any;
    imageUrl: any = environment.reportsApiBaseUrl;
    lookupDataList: any;
    url: any;
    regShgId: any;
    totalTempShgCodeDigits = 8;
    dataToString: any;
    imgBaseUrlV2: any;
    shgGuid: any;
    contGuid: any;
    totalRecord: any = 0;
    splitShgMembersListsData: any = [];
    pdfDownload!: jsPDF;
    imgData: any;
    inputPdf: any = [];
    inputFirstPage: any;
    showRefreshBtn = false;
    regType: any;
    shgKeyword: any = '';
    defaultImage = 'https://cdn.lokos.in/assets/img/avatar.png';
    docFullUrl!: string;
    imageflag: any;
    memRow: any;
    imgNameUrl: any;
    cboUuid: any;
    singleCall = false;
    contentType: any;
    headerLeader = '';

    constructor(
        private route: ActivatedRoute,
        private cdnService: CdnService,
        private voProfileService: VoProfileService,
        private shgProfileService: ShgProfileService,
        private commonService: CommonService
    ) {}

    ngOnInit(): void {
        if (window.location.href.indexOf('refresh-btn') > -1) {
            this.showRefreshBtn = true;
        } else {
            this.showRefreshBtn = false;
        }
        this.showRefreshBtn = true;

        this.route.queryParams.subscribe((params) => {
            this.shgId = params['contId'];
            this.shgName = params['shg_name'];
            this.shgCode = params['cont_code'];
            this.contId = params['contId'];
            this.contName = params['cont_name'];
            this.contCode = params['cont_code'];
            this.micCode = params['mic_code'];
            this.cboUuid = params['cont_uuid'];

            this.stateId = params['stateId'];
            this.districtId = params['districtId'];
            this.stateName = params['stateName'];
            this.distName = params['distName'];
            this.blockId = params['blockId'];
            this.panchayatId = params['panchayatId'];
            this.villageId = params['villageId'];
            this.blockName = params['blockName'];
            this.panchayatName = params['panchayatName'];
            this.villageName = params['villageName'];
            this.formationDate = params['formation_date'];
            this.shgGuid = params['contGuid'];
            this.contGuid = params['contGuid'];
            this.regType = params['regType'];
            if (this.regType === 'VO') {
                this.headerLeader = 'vo';
                this.breadcrumbs = [
                    { label: 'voProfile', link: '/main/profile/vo-profile' },
                ];
            }
            if (this.regType === 'SHG') {
                this.headerLeader = 'shg';
                this.breadcrumbs = [
                    { label: 'shgProfile', link: '/main/profile/shg-profile' },
                ];
            }
            if (this.regType === 'CLF') {
                this.headerLeader = 'clf';
                this.breadcrumbs = [
                    {
                        label: 'clfProfile',
                        link: '/main/profile/clf-profile',
                    },
                ];
            }

            this.breadcrumbs.push({
                label: 'Registration Certificate',
                link: '',
            });
        });

        // });
        this.getLookupData();
        this.loadMembers();

        this.url =
            'https://nrlm.gov.in/LokOS/uploadFiles/1000/1000_2021-12-14%2007:14:39.052_16.jpg';
        const image = new Image();
        image.src = this.url;
    }

    getLookupData() {
        this.cdnService.getLokosMasterData().subscribe({
            next: (response: any) => {
                this.lookupDataList =
                    response.find((o: any) => o.name === 'lookUpMasterList')
                        .json || [];
            },
            error: (error: any) => {
                console.error('Error fetching lookup data:', error);
            },
        });
    }

    // get temp SHG code
    getTempShgCode() {
        let tempShgCode = `T-${this.stateId}`;
        this.totalTempShgCodeDigits =
            this.totalTempShgCodeDigits - this.shgId.toString().length;
        for (let i = 0; i < this.totalTempShgCodeDigits; i++) {
            tempShgCode += '0';
        }
        tempShgCode += this.shgId.toString();
        this.shgCode = tempShgCode;
    }

    getMemberList(response: any): void {
        if (!response) return;

        this.totalRecord = response.length;
        this.enrichMembersWithDesignations(response);
        this.dataToString = JSON.stringify(this.buildCertificateData());
    }

    private enrichMembersWithDesignations(members: any[]): void {
        const requests = members
            .map((member) => {
                const lookup = this.lookupDataList.find(
                    (el: any) =>
                        el.key1 === 1 &&
                        el.lookup_code === member.designation &&
                        el.language_id === 'en'
                );

                member.mem_designation =
                    lookup?.key_value ||
                    (member.designation === 6 ? 'Other' : '');

                return this.getMemberImageObservable(member);
            })
            .filter((request) => request != null);

        if (requests.length > 0) {
            forkJoin(requests).subscribe(() => {
                this.processMembersList(members);
            });
        } else {
            this.processMembersList(members);
        }
    }

    private processMembersList(members: any[]): void {
        const activeMembers = members
            .filter((m: any) => m.status === 1)
            .map((member: any) => ({
                ...member,
                member_code:
                    this.regType === 'SHG'
                        ? member.member_code
                        : member.ec_member_code,
            }))
            .sort(
                (a: any, b: any) =>
                    a.status - b.status || a.designation - b.designation
            );

        this.shgMembersLists = activeMembers;
        this.splitShgMembersListsData = this.chunkArray(activeMembers, 8);
    }

    private buildCertificateData(): Record<string, any> {
        const baseData = {
            'MIS Code': this.micCode,
            Block: this.blockName,
            District: this.distName,
            State: this.stateName,
            'Number of members': this.shgMembersLists?.length || 0,
        };

        const typeData: Record<string, Record<string, any>> = {
            SHG: {
                'SHG Name': this.contName,
                'SHG ID': this.contCode,
                Village: this.villageName,
                GP: this.panchayatName,
            },
            VO: {
                'VO Name': this.contName,
                'VO ID': this.contCode,
                GP: this.panchayatName,
            },
            CLF: {
                'CLF Name': this.contName,
                'CLF ID': this.contCode,
            },
        };

        return { ...baseData, ...(typeData[this.regType] || {}) };
    }

    private getMemberImageObservable(member: any) {
        let imageName = member['member_image'] || '';

        if (!imageName) {
            member.imagePath = this.defaultImage;
            return of(null);
        }

        // Extract filename if full path
        if (imageName.includes('/')) {
            imageName = imageName.split('/').pop() || imageName;
        }

        const imageURL = this.commonService.formatImageUrl(
            imageName,
            { uuid: member.uuid } as { uuid: string },
            ImageTypeEnum.Profile,
            this.cboUuid
        );

        // member.member_image = imageURL;

        return this.shgProfileService.getImageFullUrl(imageURL).pipe(
            tap((response: any) => {
                if (response instanceof Blob) {
                    member.imagePath = URL.createObjectURL(response);
                } else {
                    member.imagePath = response || this.defaultImage;
                }
            }),
            catchError(() => {
                member.imagePath = this.defaultImage;
                return of(null);
            })
        );
    }

    // loadImage(item: any): void {
    //     let imageName = '';
    //     imageName = item['member_image'];

    //     if (imageName) {
    //         if (imageName && imageName.includes('/')) {
    //             imageName = imageName.split('/').pop() || '';
    //         } else if (imageName) {
    //             imageName = imageName; // Use the whole string if no slash found
    //         }
    //     }
    //     const imageURL = this.commonService.formatImageUrl(
    //         imageName,
    //         {
    //             uuid: item.uuid,
    //         } as { uuid: string },
    //         ImageTypeEnum.Profile,
    //         this.cboUuid
    //     );
    //     let blobUrl: any = null;

    //     this.shgProfileService.getImageFullUrl(imageURL).subscribe({
    //         next: (response: any) => {
    //             // Revoke previous blob URL if it exists
    //             if (blobUrl) {
    //                 URL.revokeObjectURL(blobUrl);
    //             }
    //             // Convert Blob to Object URL
    //             if (response instanceof Blob) {
    //                 blobUrl = URL.createObjectURL(response);
    //                 return blobUrl;
    //             } else {
    //                 return response;
    //             }
    //         },
    //         error: (error: any) => {
    //             console.error('Error loading image path:', error);
    //         },
    //     });
    // }

    //load SHG members
    loadMembers() {
        // this.singleCall = true;
        // this.contentType = 'member';
        if (this.regType === 'SHG') {
            this.shgProfileService.GetShgMemberList(this.cboUuid).subscribe(
                (response: any) => {
                    this.getMemberList(response);
                },
                (error) => {
                    this.errorMessage = error;
                }
            );
        }
        if (this.regType === 'VO' || this.regType === 'CLF') {
            this.contentType = 'member';
            this.voProfileService
                .getVoProfilesByFedId(this.contId, this.cboUuid)
                .subscribe(
                    (response: any) => {
                        this.getMemberList(response.ec_members_list);
                    },
                    (error) => {
                        this.errorMessage = error;
                    }
                );
        }
        if (this.regType === 'Member') {
            const data = {
                'Member Name': this.contName,
                'SHG Member ID': this.contCode,
                'MIS Code': this.micCode,
                Village: this.villageName,
                GP: this.panchayatName,
                Block: this.blockName,
                District: this.distName,
                State: this.stateName,
                'Number of members': this.shgMembersLists?.length,
            };
            this.dataToString = JSON.stringify(data);
        }
    }
    findIndex(memCode: any) {
        const pos = this.shgMembersLists
            .map((e: any) => e.member_code)
            .indexOf(memCode);
        return pos;
    }

    chunkArray(array: any[], size: number): any[][] {
        const chunks = [];
        for (let i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }
        return chunks;
    }

    // get image
    public getImagePath(imgName: any, flag: any, obj: any) {
        // let data: any;
        this.docFullUrl = imgName.includes('http');
        this.imageflag = flag;
        this.memRow = obj;
        this.imgNameUrl = imgName;
    }
    //Converted to PDF
    public convertToPDF() {
        const input = document.getElementById(
            'contentToConvert333333'
        ) as HTMLInputElement;
        this.inputPdf = [];
        if (input) {
            if (this.splitShgMembersListsData.length) {
                for (let i = 0; i < this.splitShgMembersListsData.length; i++) {
                    this.inputPdf.push(
                        document.getElementById(
                            'contentToConvert' + (i + 1)
                        ) as HTMLInputElement
                    );
                }
            }
            // Initialize PDF with explicit A4 format in landscape
            this.pdfDownload = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4',
            });

            // Convert first page (certificate)
            html2canvas(input, {
                useCORS: true,
                scale: 2,
                logging: false,
                backgroundColor: '#ffffff',
            }).then((canvas) => {
                this.imgData = canvas.toDataURL('image/png');
                const pageWidth = this.pdfDownload.internal.pageSize.getWidth();
                const pageHeight =
                    this.pdfDownload.internal.pageSize.getHeight();
                this.pdfDownload.addImage(
                    this.imgData,
                    0,
                    0,
                    pageWidth,
                    pageHeight
                );

                // If there are member list pages, add them
                if (this.inputPdf && this.inputPdf.length > 0) {
                    this.addMemberListPages();
                } else {
                    // Only first page, save immediately
                    this.pdfDownload.save('certificate.pdf');
                }
            });
        }
    }

    private addMemberListPages() {
        const pagePromises: Promise<void>[] = [];

        for (const element of this.inputPdf) {
            const promise = new Promise<void>((resolve) => {
                html2canvas(element, {
                    allowTaint: true,
                    useCORS: true,
                    scale: 2,
                    logging: false,
                    backgroundColor: '#ffffff',
                }).then((canvas) => {
                    this.imgData = canvas.toDataURL('image/png');
                    const pageWidth =
                        this.pdfDownload.internal.pageSize.getWidth();
                    const pageHeight =
                        this.pdfDownload.internal.pageSize.getHeight();

                    // Add new page for each member list (except after first page already added)
                    this.pdfDownload.addPage();
                    this.pdfDownload.addImage(
                        this.imgData,
                        0,
                        0,
                        pageWidth,
                        pageHeight
                    );
                    resolve();
                });
            });
            pagePromises.push(promise);
        }

        // Wait for all pages to be rendered before saving
        Promise.all(pagePromises).then(() => {
            this.pdfDownload.save('certificate.pdf');
        });
    }
    tableHieght(totalList: any) {
        let canvasHeight = 280;
        if (totalList === 1) {
            canvasHeight = 70;
        } else if (totalList === 2) {
            canvasHeight = 94;
        } else if (totalList === 3) {
            canvasHeight = 118;
        } else if (totalList === 4) {
            canvasHeight = 142;
        } else if (totalList === 5) {
            canvasHeight = 166;
        } else if (totalList === 6) {
            canvasHeight = 190;
        } else if (totalList === 7) {
            canvasHeight = 214;
        } else if (totalList === 8) {
            canvasHeight = 238;
        } else if (totalList === 9) {
            canvasHeight = 262;
        }
        return canvasHeight;
    }

    printPage() {
        // Get the element to print
        const contentToPrint = document.getElementById('contentToConvert222');
        if (!contentToPrint) {
            console.error('Content to print not found');
            return;
        }

        // Wait for QR code to render, then print
        setTimeout(() => {
            // Clone the content
            const clonedContent = contentToPrint.cloneNode(true) as HTMLElement;

            // Convert QR code SVG to canvas and then to image
            const qrcodeElements = clonedContent.querySelectorAll('qrcode');
            const cvases: Promise<void>[] = [];

            qrcodeElements.forEach((qrElement) => {
                const qrSvg = qrElement.querySelector('svg');
                if (qrSvg) {
                    const promise = new Promise<void>((resolve) => {
                        try {
                            const canvas = document.createElement('canvas');
                            const ctx = canvas.getContext('2d');
                            const img = new Image();
                            const svgData =
                                new XMLSerializer().serializeToString(qrSvg);
                            const svg = new Blob([svgData], {
                                type: 'image/svg+xml',
                            });
                            const url = URL.createObjectURL(svg);

                            img.onload = () => {
                                canvas.width = qrSvg.clientWidth;
                                canvas.height = qrSvg.clientHeight;
                                ctx?.drawImage(img, 0, 0);
                                const imgElement =
                                    document.createElement('img');
                                imgElement.src = canvas.toDataURL('image/png');
                                imgElement.style.width =
                                    qrSvg.clientWidth + 'px';
                                imgElement.style.height =
                                    qrSvg.clientHeight + 'px';
                                qrElement.replaceWith(imgElement);
                                URL.revokeObjectURL(url);
                                resolve();
                            };

                            img.onerror = () => {
                                URL.revokeObjectURL(url);
                                resolve();
                            };

                            img.src = url;
                        } catch (e) {
                            console.warn('Error converting QR code:', e);
                            resolve();
                        }
                    });
                    cvases.push(promise);
                }
            });

            Promise.all(cvases).then(() => {
                this.printContent(clonedContent);
            });
        }, 100);
    }

    private printContent(contentElement: HTMLElement) {
        // Create a new window for printing
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            console.error('Failed to open print window');
            return;
        }

        // Get the current document's stylesheets
        const styles = Array.from(document.styleSheets)
            .map((sheet) => {
                try {
                    return Array.from(sheet.cssRules)
                        .map((rule) => rule.cssText)
                        .join('\n');
                } catch {
                    console.warn('Cannot access stylesheet:', sheet);
                    return '';
                }
            })
            .join('\n');

        // Write HTML to the new window
        const printContent = contentElement.innerHTML;
        const htmlContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Certificate</title>
                <style>
                    ${styles}
                    * {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        color-adjust: exact !important;
                    }
                    @page {
                        size: A4 landscape;
                        margin: 0;
                    }
                    html, body {
                        margin: 0;
                        padding: 0;
                        width: 297mm;
                        height: 210mm;
                    }
                    body {
                        font-family: 'Montserrat', sans-serif;
                    }
                </style>
            </head>
            <body>
                ${printContent}
                <script>
                    window.onload = function() {
                        setTimeout(function() {
                            window.print();
                            window.close();
                        }, 500);
                    };
                </script>
            </body>
            </html>
        `;

        printWindow.document.write(htmlContent);
        printWindow.document.close();
    }

    onImgError(image: any) {
        image.target.src = 'https://cdn.lokos.in/assets/img/avatar.png';
    }

    onMemberImageError(member: any): void {
        if (member) {
            member.imageLoadFailed = true;
        }
    }

    goToLinkedMemberScreen() {
        // intentionally left blank
    }
}
